import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import ChatHeader from './ChatHeader';
import { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/UI';
import { Img } from 'react-image';
import { Link } from 'react-router-dom';

interface FreePlanProps {
    onBackButton: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%'
        },
        title: {
            fontSize: '42px',
            fontWeight: 600,
            lineHeight: '100%',
            margin: '16px 0',
            textAlign: 'center'
        },
        description: {
            textAlign: 'center',
            fontFamily: 'Poppins',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '24px',
            marginBottom: '16px'
        },
        backButton: {
            cursor: 'pointer'
        },
        infoContainer: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            justifyContent: 'flex-end',
            padding: '0 96px',
            paddingBottom: '82px'
        },
        icon: {
            fontSize: '15px',
            fontWeight: 'bold'
        },
        imageContainer: {
            display: 'flex'
        },
        image: {
            width: '100%',
            height: 'auto'
        },
        badge: {
            alignItems: 'center',
            backgroundColor: '#FAEFDF',
            borderRadius: '15px',
            color: '#000000',
            display: 'inline-flex',
            flexDirection: 'row',
            fontSize: '14px',
            fontWeight: 600,
            gap: '8px',
            padding: '6px 10px'
        },
        premiumButton: {
            'padding': '14px 36px',
            'height': '55px',

            '& span': {
                fontSize: '18px'
            }
        }
    })
);

const FreePlan: FunctionComponent<FreePlanProps> = props => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div>
                <ChatHeader onBackButton={props.onBackButton} />
            </div>
            <div className={classes.infoContainer}>
                <span className={classes.badge}>
                    <FontAwesomeIcon
                        className={classes.icon}
                        icon={faSparkles}
                    />
                    Premium
                </span>
                <h1 className={classes.title}>Tw0-Way SMS</h1>
                <span className={classes.description}>
                    Simplify communication with Two-Way SMS. Send and receive texts seamlessly and keep conversations
                    organized.
                </span>
                <Link to="/business_settings/info/plans">
                    <Button
                        label="Upgrade Today"
                        className={classes.premiumButton}
                    />
                </Link>
            </div>
            <div className={classes.imageContainer}>
                <Img
                    src="/images/premium/not-premium-doggie.png"
                    className={classes.image}
                />
            </div>
        </div>
    );
};

export default FreePlan;
